// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__c8IMj","page":"pagination_page__phx7s","page_active":"pagination_page_active__ZT-Rw"};